import { METRICS, SOCIAL_PLATFORMS } from '~/constants';
import { MediaPackBenchmarkType, TMediaPackPosition } from '~/types';

import {
  METRIC_CONFIG,
  METRIC_POSITION_DEFAULT,
} from './MediaPackDetailEditHighlightsModal.constants';
import {
  IMetricConfig,
  IMetricConfigMulti,
  IMetricConfigSingle,
} from './MediaPackDetailEditHighlightsModal.types';

interface ILayoutOptions {
  platform: SOCIAL_PLATFORMS;
  position?: TMediaPackPosition;
}

export const createDefaultLayout = ({
  platform,
  position = METRIC_POSITION_DEFAULT,
}: ILayoutOptions) => {
  const config = METRIC_CONFIG[platform];
  const platformPosition = position[platform];
  return Object.entries(platformPosition).reduce((acc, [key, value]) => {
    const metric = key as METRICS;
    const defaultValue = config[metric].defaultMetricKey;
    if (!value.length) {
      acc[metric] = Array.isArray(defaultValue) ? defaultValue : [defaultValue];
    }
    return acc;
  }, platformPosition);
};

interface IChangeBenchmark<MetriConfig = IMetricConfig> {
  benchmark: MediaPackBenchmarkType;
  metricActive: METRICS;
  metricConfig: MetriConfig;
  metricsPosition: { [k in METRICS]: MediaPackBenchmarkType[] };
}

const changeSingleBenchmark = ({
  benchmark,
  metricActive,
  metricsPosition,
}: IChangeBenchmark<IMetricConfigSingle>): MediaPackBenchmarkType[] => {
  const isChecked = metricsPosition[metricActive].includes(benchmark);
  return isChecked ? [] : [benchmark];
};

const changeMultiBenchmark = ({
  benchmark,
  metricActive,
  metricConfig: { maxMetricCount },
  metricsPosition,
}: IChangeBenchmark<IMetricConfigMulti>): MediaPackBenchmarkType[] => {
  const isChecked = metricsPosition[metricActive].includes(benchmark);
  const activeMetricsPosition = [...metricsPosition[metricActive]];

  if (isChecked) {
    return activeMetricsPosition.filter((key) => key !== benchmark);
  }

  activeMetricsPosition.push(benchmark);

  if (activeMetricsPosition.length > maxMetricCount) {
    activeMetricsPosition.shift();
  }

  return activeMetricsPosition;
};

export const changeBenchmark = (options: IChangeBenchmark) => {
  if (options.metricConfig.isMultiselect) {
    return changeMultiBenchmark(
      options as IChangeBenchmark<IMetricConfigMulti>,
    );
  } else {
    return changeSingleBenchmark(
      options as IChangeBenchmark<IMetricConfigSingle>,
    );
  }
};
